import Reveal from "@/components/Reveal";
import { IMAGES, SITE } from "@/data/site";

const CHAPTERS = [
  {
    n: "01",
    title: "Philosophy",
    body: "Jordan has always been passionate about health, wellness, and the mind-body connection. As a Registered Massage Therapist based in Vancouver, BC, he is dedicated to helping clients find relief from pain, reduce stress, and improve overall well-being through personalized care.",
  },
  {
    n: "02",
    title: "Approach",
    body: "Jordan's holistic approach addresses both the physical and mental aspects of wellness — whether you're managing chronic pain, recovering from an injury, or seeking relief from everyday tension. Drawing on a range of techniques including Instrument Assisted Soft Tissue Mobilization (IASTM), he tailors each treatment to your individual needs with care and precision.",
  },
  {
    n: "03",
    title: "Background",
    body: "A proud graduate of the Langara College RMT program, Jordan aims to empower every client to reconnect with their body, fostering balance and ease in daily life. Outside the clinic, he enjoys exploring nature, practicing mindfulness, and staying active to maintain his own wellness and balance.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
              <span className="h-px w-10 bg-clay" /> About me
            </p>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="about-heading">
              Helping you reconnect with your body.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="mt-12">
            <div className="relative w-fit">
              <img
                src="/images/jordan.jpg"
                alt="Jordan Martel, Registered Massage Therapist in Vancouver"
                data-testid="about-image"
                className="w-full max-w-[300px] rounded-[2rem] object-cover"
              />
              <p className="absolute -bottom-5 left-6 rounded-full bg-pine px-5 py-2 text-xs uppercase tracking-[0.2em] text-bone" data-testid="about-photo-caption">
                {SITE.name}, {SITE.credential} · {SITE.pronouns}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center lg:col-span-6 lg:col-start-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <article className="border-b border-sand py-10 first:pt-0" data-testid={`about-chapter-${c.n}`}>
                <div className="flex items-baseline gap-6">
                  <span className="font-serif text-sm italic text-clay">{c.n}.</span>
                  <div>
                    <h3 className="font-serif text-2xl font-light tracking-tight text-forest lg:text-3xl">{c.title}</h3>
                    <p className="mt-4 max-w-lg text-sm leading-relaxed text-forest/70 lg:text-base">{c.body}</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
          <Reveal delay={0.4}>
            <p className="pt-10 font-serif text-2xl italic text-pine" data-testid="about-signature">
              — {SITE.name}, {SITE.credential}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
